import script from "./TaskCounterLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskCounterLabel.vue?vue&type=script&setup=true&lang=js"

import "./TaskCounterLabel.vue?vue&type=style&index=0&id=3fb3929a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb3929a"]])

export default __exports__